import { produce } from 'immer';
import { nanoid } from 'nanoid';

import { canvasActionTypes } from './canvas.types';

function sortByRolePriority(members) {
    const rolePriority = ['owner', 'admin', 'edit', 'comment', 'view'];
    return members.sort((a, b) => {
        return rolePriority.indexOf(a.role) - rolePriority.indexOf(b.role);
    });
}

const initialState = {
    diagramMembers: [],
    diagramInvites: [],
};

const canvasReducer = (state = initialState, action) => {
    if (state.isStoredState) {
        state = { ...initialState, ...state, isStoredState: false };
    }

    return produce(state, (draft) => {
        switch (action.type) {

            // FETCH DIAGRAM MEMBERS
            case canvasActionTypes.FETCH_DIAGRAM_MEMBERS_SUCCESS: {
                draft.loading = false;
                // draft.diagrams = (action.payload.data || []).sort((a, b) => new Date(b.updated_at.replace(' ', 'T')) - new Date(a.updated_at.replace(' ', 'T')));
                draft.diagramMembers = sortByRolePriority(action.payload.data || []);
                draft.error = null;
                break;
            }
            case canvasActionTypes.FETCH_DIAGRAM_MEMBERS_FAILURE: {
                draft.loading = false;
                draft.error = action.payload;
                break;
            }
            // FETCH DIAGRAM INVITES
            case canvasActionTypes.FETCH_DIAGRAM_INVITES_SUCCESS: {
                draft.loading = false;
                // draft.diagrams = (action.payload.data || []).sort((a, b) => new Date(b.updated_at.replace(' ', 'T')) - new Date(a.updated_at.replace(' ', 'T')));
                draft.diagramInvites = action.payload.data || [];
                draft.error = null;
                break;
            }
            case canvasActionTypes.FETCH_DIAGRAM_INVITES_FAILURE: {
                draft.loading = false;
                draft.error = action.payload;
                break;
            }

            default:
                break;
        }
    });
};

export default canvasReducer;
